import React from "react";

import PropTypes from "prop-types";
import { Autocomplete } from "@react-google-maps/api";
import { searchIcon, Icon } from "@lululemon/dsp-ecom-pattern-library";
import formatDistanceLabel from "../format-distance-label/format-distance-label";
import styles from "./location-picker.module.scss";
import StoreLocatorFilter from "../../store-locator-filter/store-locator-filter";
import { convertToCountryCode } from "@lululemon/mwa-i18n";
import { useRouter } from "next/router";

const LocationPicker = ({
  handleOnPlaceChanged,
  handleOnApplyFilters,
  hasSearchedForPlace,
  storeListLength,
  isMobileView,
  isModalView
}) => {
  const [autocomplete, setAutocomplete] = React.useState(null);
  const { locale } = useRouter();

  const userLocaleCountry = convertToCountryCode(locale);

  const onLoad = React.useCallback((ref) => {
    setAutocomplete(ref);
  }, []);

  const onPlaceChanged = React.useCallback(
    () => {
      if (autocomplete) {
        handleOnPlaceChanged(autocomplete.getPlace());
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [autocomplete]
  );

  const onFilterChanged = React.useCallback((selectedFilters) => {
    handleOnApplyFilters(selectedFilters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const distanceLabel = formatDistanceLabel(userLocaleCountry, 50000);

  return (
    <>
      <div className={styles.inputWrapper}>
        <Icon
          content={searchIcon}
          className={styles.searchIcon}
          title="searchIcon"
        />
        <Autocomplete
          onLoad={onLoad}
          onPlaceChanged={onPlaceChanged}
          className={styles.googleMapFilter}
        >
          <input
            className={`${styles.input} lll-text-body-2`}
            type="search"
            placeholder="Find your nearest store"
            data-lulu-privacy="1"
          />
        </Autocomplete>
        <StoreLocatorFilter
          onFilterChanged={onFilterChanged}
          isMobileView={isMobileView}
          isModalView={isModalView}
        />
      </div>
      {hasSearchedForPlace ? (
        /**  Added key for onlink should trigger based on storeListLength */
        <p key={`${storeListLength}km_${distanceLabel}_distance`}>
          Showing {storeListLength} stores within {distanceLabel}
        </p>
      ) : (
        <p>Search for a store nearest to you</p>
      )}
    </>
  );
};

LocationPicker.propTypes = {
  handleOnPlaceChanged: PropTypes.func,
  handleOnApplyFilters: PropTypes.func,
  hasSearchedForPlace: PropTypes.bool,
  storeListLength: PropTypes.number,
  isMobileView: PropTypes.bool,
  isModalView: PropTypes.bool
};

LocationPicker.defaultProps = {
  handleOnPlaceChanged: () => {},
  handleOnApplyFilters: () => {},
  hasSearchedForPlace: false,
  storeListLength: 0,
  isMobileView: false,
  isModalView: false
};

export default LocationPicker;
